import { NotifyTypo, NotifyIcon, Loader } from 'web-components';
import { Box, Card, CardHeader, Tooltip, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PlcType } from '../../../../attrs/plcConfigValues';

interface AutomationSystemConfigurationLoaderProps {
  automationSystem: {
    plc_type: string;
  };
}

const AutomationSystemConfigurationLoader = ({ automationSystem }: AutomationSystemConfigurationLoaderProps) => {
  const { t } = useTranslation();

  const automationSystemConfigLabelAmend = 'machines.detail.automation_system.configuration';

  return (
    <Card sx={{ p: 4, my: 2 }}>
      <CardHeader
        sx={{ p: 0, alignItems: 'flex-start', mb: 0 }}
        action={
          <Tooltip
            title={t('machines.detail.plc_not_filled')}
            disableHoverListener={automationSystem.plc_type !== PlcType.UNKNOWN}
            arrow
          >
            <span>
              <Button
                variant="text"
                disabled={true}
                sx={{ p: 1.5, gap: 1, display: 'flex', height: '50px', width: '96px' }}
              >
                <NotifyIcon iconName="edit" fontSize="medium" />
                {t('machines.machine_details.edit')}
              </Button>
            </span>
          </Tooltip>
        }
        title={
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ mt: '15px', fontSize: '16px' }}>{t(`${automationSystemConfigLabelAmend}.title`)}</Box>
          </Box>
        }
        titleTypographyProps={{
          fontWeight: '500',
          variant: 'body1'
        }}
      />
      <NotifyTypo.Subtitle1 fontWeight="400" sx={{ mb: '30px' }}>
        {t(`${automationSystemConfigLabelAmend}.subtitle`)}
      </NotifyTypo.Subtitle1>
      <Box sx={{ my: '20px' }}>
        <Loader />
      </Box>
    </Card>
  );
};

export default AutomationSystemConfigurationLoader;
